module.exports = __webpack_public_path__ + "static/media/handshake.f9ce98ae.png";